<template>
    <div id="advantages">
       <div v-if="$scope.IS_REGULAR_CUSTOMER && !$scope.referral_token">

            <div v-if="!isLoginPage()">
                <div v-if="!hidePromoBanner && $scope.PROMO && $scope.PROMO.img_promo">
                    <a :href="$scope.PROMO.banner_top_link" id="top-promo-image">
                        <div id="top-promo-image-mobile" v-if="$scope.PROMO.img_promo_mobile">
                            <img class="lazy lazy-fade hidden-xs-up img-responsive"
                                 :data-src="`${$scope.CDN_IMAGES}/${$scope.PROMO.img_promo_mobile}?auto=format&lossless=1`"
                                 :alt="$scope.PROMO.img_promo_alt"/>
                            <Countdown class="d-block hidden-xs-up" :deadline="this.promoEndDate"
                                       v-if="showCountdown()"/>
                        </div>

                        <div id="top-promo-image-desktop" :class="{'hidden-xs-down': $scope.PROMO.img_promo_mobile}">
                            <img id="top-promo-image-background"
                                 :data-src="`${$scope.CDN_IMAGES}/${$scope.PROMO.img_promo_fundo}?auto=format&lossless=1`"
                                 :alt="$scope.PROMO.img_promo_alt"
                                 class="lazy lazy-fade">
                            <div id="top-promo-image-foreground" class="d-flex">
                                <Countdown class="d-block " :deadline="this.promoEndDate" v-if="showCountdown()"/>
                                <img data-position="topo-site"
                                     :data-src="`${$scope.CDN_IMAGES}/${$scope.PROMO.img_promo}?auto=format&lossless=1`"
                                     :alt="$scope.PROMO.img_promo_alt"
                                     class="lazy lazy-fade img-responsive">
                            </div>
                        </div>
                    </a>

                    <div class="botao-regulamento text-center cursor-pointer text-uppercase text-yanone text-underline"
                         @click="showRegulamento = true" v-if="$scope.regulamento">
                        Confira o regulamento
                    </div>

                    <Modal v-model="showRegulamento" class="modal-regulamento" v-if="$scope.regulamento"
                           :class="{'modal-black': $scope.promo_group && $scope.isCustomerInGroup}">
                        <div>
                            <div class="cr-modal-header">
                                <img class="banner-regulamento" v-if="$scope.PROMO.bannerRules"
                                     :src="`${$scope.CDN_IMAGES}/images/site/promos/${$scope.PROMO.bannerRules}?auto=format&lossless=1`">
                            </div>
                        </div>
                        <div class="card-block">
                            <h2>Regulamento</h2>
                            <div v-html="$scope.regulamento"></div>
                        </div>
                        <div class="card-block text-right">
                            <button type="button" class="btn" @click="showRegulamento = false">Fechar</button>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>



        <div v-else-if="$scope.referral_token && !isLoginPage()">
            <a href="cadastrar">
                <picture>
                    <source media="(max-width: 768px)"
                            :srcset="`${$scope.CDN_IMAGES}/images/site/2017/minha-conta/bnr_indica_direcionamento_mob_768x100.jpg?auto=format&lossless=1`">
                    <img class="lazy img-responsive center-block"
                         :data-src="`${$scope.CDN_IMAGES}/images/site/2017/minha-conta/bnr_indica_direcionamento_1250x100.jpg?auto=format&lossless=1`"
                         alt="Indica Chico Rei"/>
                </picture>
            </a>
        </div>
    </div>
</template>

<script>
    import {lazyLoadInstance, timeHandler} from '../../../common/common';
    import Countdown from "./Countdown";
    import Modal from "./container/Modal";

    export default {
        name: 'Advantages',
        components: {Countdown, Modal},
        props: ['hidePromoBanner'],

        data() {
            return {
                promoStartDate: timeHandler(this.$scope.PROMO ? this.$scope.PROMO.data_inicio : '').toDate(),
                promoEndDate: timeHandler(this.$scope.PROMO ? this.$scope.PROMO.data_fim : '').toDate(),
                showRegulamento: false,
                showCovidInfo: false
            }
        },

        mounted() {
            if (lazyLoadInstance) {
                lazyLoadInstance.update();
            }
        },

        methods: {
            isLoginPage() {
                return false;
            },
            showCountdown() {
                if (this.$scope.PROMO.contador !== '1' || !this.promoStartDate || !this.promoEndDate) {
                    return false;
                }

                const now = new Date();
                const diff = this.promoEndDate.getTime() - now.getTime();
                return this.promoStartDate < now && this.promoEndDate > now && diff < 2 * 24 * 3600 * 1000;
            },
        }
    }
</script>